import {Component, OnInit} from '@angular/core';
import {ArticleService} from '../../core/services/article/article.service';
import {ArticleCategoryModel} from '../../core/models/article/article-category.model';
import {RouterLink} from '@angular/router';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-guides',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    TranslateModule
  ],
  templateUrl: './guides.component.html',
  styleUrl: './guides.component.scss'
})
export class GuidesComponent implements OnInit {

  loading: boolean = false;
  error: string | null = null;
  guideCategories: ArticleCategoryModel[] = [];

  constructor(private readonly articleService: ArticleService) {
  }

  ngOnInit(): void {
    this.loadCategories();
  }

  loadCategories(): void {
    this.loading = true;
    this.articleService.getArticleCategoriesByType(2)
      .subscribe({
        next: (response) => {
          this.guideCategories = response;
          this.loading = false;
        },
        error: (err) => {
          console.error('Error loading articles', err);
          this.error = 'Error loading articles. Please try again later.';
          this.loading = false;
        }
      });
  }
}
